import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import ThemeProvider from './theme/ThemeProvider';
import ScrollToTop from './components/ScrollToTop';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Hero from './components/Hero';
import PainSolutionSection from './components/PainSolutionSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import UseCasesSection from './components/UseCasesSection';
import DashboardPreviewSection from './components/DashboardPreviewSection';
import TestimonialsSection from './components/TestimonialsSection';
import BetaOfferSection from './components/BetaOfferSection';
import CTABanner from './components/CTABanner';

import SEO from './components/SEO';
import WhatsAppWidget from './components/WhatsAppWidget';
import Pricing from './pages/Pricing';
import Features from './pages/Features';
import Contact from './pages/Contact';
import About from './pages/About';
import Documentation from './pages/Documentation';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import HelpCenter from './pages/HelpCenter';
import SystemStatus from './pages/SystemStatus';
import ApiReference from './pages/ApiReference';
import UseCases from './pages/UseCases';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CookiePolicy from './pages/CookiePolicy';

const Home = () => (
  <div className="page-shell">
    <SEO
      title="Mobile-First Call Center Platform — Auto Dialer & Lead Management"
      description="Replace expensive call center hardware with WASLX. Auto dialer, live agent monitoring, lead management & analytics — all from Android smartphones. Free 1-month beta, no credit card."
      path="/"
    />
    <Navbar />
    <Hero />
    <PainSolutionSection />
    <FeaturesSection />
    <HowItWorksSection />
    <UseCasesSection />
    <DashboardPreviewSection />
    <TestimonialsSection />
    <BetaOfferSection />
    <CTABanner />
    <Footer />
  </div>
);

function App() {
  return (
    <ThemeProvider>
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/"          element={<Home />} />
          <Route path="/features"  element={<Features />} />
          <Route path="/pricing"   element={<Pricing />} />
          <Route path="/contact"   element={<Contact />} />
          <Route path="/about"         element={<About />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/blog"          element={<Blog />} />
          <Route path="/careers"       element={<Careers />} />
          <Route path="/help"          element={<HelpCenter />} />
          <Route path="/status"        element={<SystemStatus />} />
          <Route path="/api-reference" element={<ApiReference />} />
          <Route path="/use-cases"     element={<UseCases />} />
          <Route path="/privacy"       element={<Privacy />} />
          <Route path="/terms"         element={<Terms />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/products"      element={<Features />} />
          <Route path="/resources"     element={<Contact />} />
          <Route path="/login"         element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppWidget />
    </div>
    </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
